export default __webpack_public_path__ + "static/media/HOME_BANNER_3.0384df50.png";